import React from 'react';

export const ProductSkeleton: React.FC = () => {
  return (
    <div className="rounded-3xl border border-slate-150/60 overflow-hidden flex flex-col justify-between bg-slate-50/20 relative animate-pulse">
      {/* Container de la Imagen con Shimmer */}
      <div className="relative aspect-square w-full bg-slate-200/80 overflow-hidden border-b border-slate-150/50 flex items-center justify-center shimmer">
        {/* Este div obtiene el efecto shimmer gracias a la clase .shimmer definida en el CSS */}
      </div>

      {/* Placeholders de Contenido */}
      <div className="p-5 flex-1 flex flex-col justify-between space-y-5">
        {/* Categoría y Título */}
        <div className="space-y-3">
          <div className="h-3.5 bg-slate-200/85 rounded-full w-1/4" />
          <div className="space-y-2">
            <div className="h-5 bg-slate-200 rounded-2xl w-5/6" />
            <div className="h-5 bg-slate-200 rounded-2xl w-1/2" />
          </div>
          <div className="space-y-1.5 pt-1">
            <div className="h-3 bg-slate-100 rounded w-full" />
            <div className="h-3 bg-slate-100 rounded w-4/5" />
          </div>
        </div>

        {/* Talles Selector Placeholder */}
        <div className="space-y-2.5">
          <div className="h-3 bg-slate-150 rounded w-1/3" />
          <div className="flex gap-1.5">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="w-8 h-8 rounded-xl bg-slate-200/70" />
            ))}
          </div>
        </div>

        {/* Precio y Botones Placeholder */}
        <div className="space-y-3 pt-3 border-t border-slate-150/50">
          <div className="flex justify-between items-center">
            <div className="space-y-1">
              <div className="h-2.5 bg-slate-150 rounded w-10" />
              <div className="h-5 bg-slate-200 rounded-lg w-24" />
            </div>
          </div>

          <div className="flex flex-col gap-2 pt-1">
            <div className="h-11 bg-slate-200/90 rounded-xl w-full" />
            <div className="h-10 bg-slate-100 rounded-xl w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const ProductSkeletonGrid: React.FC<{ count?: number }> = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, idx) => (
        <ProductSkeleton key={idx} />
      ))}
    </div>
  );
};
